export function isObjectEmpty(object: Object | undefined) { return !object || Object.keys(object).length === 0 }
